import { CheckOut } from "./CheckOut";

export default CheckOutimport { CheckOut } from "./CheckOut";

export default CheckOut